import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: "/login",
    name: 'login',
    component: () => import('../views/login/login.vue')
  },
  // {
  //   path: "/",
  //   name: 'home',
  //   component: () => import('../views/Game/home')
  // },
  {
    path: "/Game/game",
    name: 'game',
    component: () => import('../views/Game/game')
  },
  {
    path: "/Game/caseEdit",
    name: 'caseEdit',
    component: () => import('../views/Game/caseEdit')
  },
  {
    path: "/Game/typeEdit",
    name: 'typeEdit',
    component: () => import('../views/Game/typeEdit')
  },
  
  {
    path: "/planthome",
    name: 'planthome',
    component: () => import('../views/plant/component/Home.vue')
  },

  // {
  //   path: "/cockpit",
  //   name: 'cockpit',
  //   component: () => import('../views/plant/cockpit/cockpit.vue')
  // },
  {
    path: "/cockpit1",
    name: 'cockpit1',
    component: () => import('../views/plant/cockpit/cockpit1.vue')
  },
  {
    path: "/coursehome",
    name: 'coursehome',
    component: () => import('../views/course/home/courseHome.vue')
  },
  {
    path: "/coursedetail",
    name: 'coursedetail',
    component: () => import('../views/course/detail/courseDetail.vue')
  },
  {
    path: "/coursevideo",
    name: 'coursevideo',
    component: () => import('../views/course/detail/courseVideo.vue')
  },
  {
    path: "/Game/scratch",
    name: 'scratch',
    component: () => import('../views/Game/scratch')
  },
  // 未匹配到的路由统一重定向到 cockpit1（主控制台）
  {
    path: '/',
    redirect: '/cockpit1'
  },
  {
    path: '*',
    redirect: '/cockpit1'
  },
]

const router = new VueRouter({
  routes,
  mode: 'hash',
  base: process.env.BASE_URL,
})

// 需要登录验证的路由（排除登录页和部分公开页面）
const authRequiredRoutes = [
  // '/cockpit',
  '/cockpit1',
  '/planthome',
  '/coursehome',
  '/coursedetail',
  '/coursevideo',
  '/Game/game',
  '/Game/caseEdit',
  '/Game/typeEdit',
  '/Game/scratch'
]

// 路由守卫：检查登录状态
router.beforeEach((to, from, next) => {
  // 检查是否需要登录验证
  const requiresAuth = authRequiredRoutes.some(route => to.path.startsWith(route))
  
  if (requiresAuth) {
    // 检查登录信息：必须有用户ID和用户名
    const userId = localStorage.getItem('ms_userId')
    const username = localStorage.getItem('ms_username')
    
    // 如果没有用户ID或用户名，说明未登录
    if (!userId || !username) {
      // 清除可能存在的无效数据
      localStorage.removeItem('ms_userId')
      localStorage.removeItem('ms_username')
      localStorage.removeItem('ms_lastLoginTime')
      localStorage.removeItem('ms_greenhouseId')
      
      // 跳转到登录页
      next({
        path: '/login',
        query: { redirect: to.fullPath } // 保存目标路径，登录后可以跳转回来
      })
    } else {
      // 已登录，允许访问
      next()
    }
  } else {
    // 不需要登录验证的页面（如登录页、首页等），直接放行
    next()
  }
})

export default router
